// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/api/organizations/firstparty/v5/patch_capital_deposit.proto

/* eslint-disable */

/** Request for updating capital deposit information. */
export interface ApiPatchCapitalDepositRequest {
  /** Source of the bylaw provider (e.g., "cabinet_expert_comptable"). */
  readonly providerSource?:
    | string
    | null
    | undefined;
  /** Contact email of the bylaw provider. */
  readonly providerSourceContactEmail?: string | null | undefined;
}

/** Response for updating capital deposit information. */
export interface ApiPatchCapitalDepositResponse {
  /** Source of the bylaw provider (e.g., "cabinet_expert_comptable"). */
  readonly providerSource?:
    | string
    | null
    | undefined;
  /** Contact email of the bylaw provider. */
  readonly providerSourceContactEmail?: string | null | undefined;
}

export const ApiPatchCapitalDepositRequest: MessageFns<ApiPatchCapitalDepositRequest> = {
  fromJSON(object: any): ApiPatchCapitalDepositRequest {
    return {
      providerSource: isSet(object.providerSource) ? globalThis.String(object.providerSource) : null,
      providerSourceContactEmail: isSet(object.providerSourceContactEmail)
        ? globalThis.String(object.providerSourceContactEmail)
        : null,
    };
  },

  toJSON(message: ApiPatchCapitalDepositRequest): unknown {
    const obj: any = {};
    if (message.providerSource !== undefined && message.providerSource !== null) {
      obj.providerSource = message.providerSource;
    }
    if (message.providerSourceContactEmail !== undefined && message.providerSourceContactEmail !== null) {
      obj.providerSourceContactEmail = message.providerSourceContactEmail;
    }
    return obj;
  },
};

export const ApiPatchCapitalDepositResponse: MessageFns<ApiPatchCapitalDepositResponse> = {
  fromJSON(object: any): ApiPatchCapitalDepositResponse {
    return {
      providerSource: isSet(object.providerSource) ? globalThis.String(object.providerSource) : null,
      providerSourceContactEmail: isSet(object.providerSourceContactEmail)
        ? globalThis.String(object.providerSourceContactEmail)
        : null,
    };
  },

  toJSON(message: ApiPatchCapitalDepositResponse): unknown {
    const obj: any = {};
    if (message.providerSource !== undefined && message.providerSource !== null) {
      obj.providerSource = message.providerSource;
    }
    if (message.providerSourceContactEmail !== undefined && message.providerSourceContactEmail !== null) {
      obj.providerSourceContactEmail = message.providerSourceContactEmail;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
